import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type HorseContactEntityTableName = 'horse_contacts';

export type PreparedHorseContactData = {
    record: Model;
    table: HorseContactEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: HorseContactEntityTableName,
    operation: ValidationOperation,
): PreparedHorseContactData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedHorseContactData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
